module.exports = __webpack_public_path__ + "static/media/Post_IL_Icon.8f1cc0f2.png";